<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  @if (description) {
    <div class="text-muted m-b-15">{{ description }}</div>
  }
  <input type="text" class="form-control m-b-15" placeholder="Filter groups…" [(ngModel)]="query" />
  <div class="border-radius10 p-10 trans-bg" style="max-height: 400px; overflow-y: auto">
    @if (!filteredGroups.length) {
      <div class="text-muted text-center p-20">No groups match "{{ query }}".</div>
    }
    @for (group of filteredGroups; track group.id) {
      <div class="form-check">
        <input class="form-check-input" type="checkbox" [id]="'select-group-' + group.id" [checked]="workingMap[group.name]" (change)="toggle(group.name)" />
        <label class="form-check-label" [for]="'select-group-' + group.id">
          <strong>{{ group.name }}</strong>
          @if (group.description) {
            <span class="text-muted">— {{ group.description }}</span>
          }
        </label>
      </div>
    }
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-link" (click)="activeModal.dismiss('Cancel')">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="save()">Save</button>
</div>
